import React, { useState, createContext, useContext } from 'react';
export interface Product {
  id: number;
  name: string;
  price: string;
  priceValue: number;
  rating: number;
  reviews: number;
  image: string;
  description: string;
  badge?: string;
  category?: string;
}
export interface CartItem {
  product: Product;
  quantity: number;
}
interface CartContextType {
  cartItems: CartItem[];
  addToCart: (product: Product) => void;
  removeFromCart: (productId: number) => void;
  getTotalPrice: () => number;
}
const CartContext = createContext<CartContextType | undefined>(undefined);
export const CartProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const addToCart = (product: Product) => {
    setCartItems(prevItems => {
      const existingItem = prevItems.find(item => item.product.id === product.id);
      if (existingItem) {
        return prevItems.map(item => item.product.id === product.id ? {
          ...item,
          quantity: item.quantity + 1
        } : item);
      }
      return [...prevItems, {
        product,
        quantity: 1
      }];
    });
  };
  const removeFromCart = (productId: number) => {
    setCartItems(prevItems => prevItems.filter(item => item.product.id !== productId));
  };
  const getTotalPrice = () => {
    return cartItems.reduce((total, item) => total + item.product.priceValue * item.quantity, 0);
  };
  return <CartContext.Provider value={{
    cartItems,
    addToCart,
    removeFromCart,
    getTotalPrice
  }} data-id="element-520">
      {children}
    </CartContext.Provider>;
};
export const useCart = () => {
  const context = useContext(CartContext);
  if (context === undefined) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};